
import Vue from 'vue'
import axios from "@/axios.js"

export default {
  login({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/auth/login", data)
        .then((response) => {
          dispatch('attempt', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  attempt({ commit, state , dispatch }, data) {
    if(data.access_token){
      commit('SET_TOKEN',data.access_token)
    }
    if(!state.token){
      return
    }
    
    try {

      if(data.user){
        commit('SET_USER', data.user )
        commit('SET_ROLE', data.user.role)
      }else{
        return new Promise((resolve, reject) => {
          axios.post("/auth/me")
            .then((response) => {
            
              if(response.data.success == false){
                dispatch('attempt', data.access_token)
              }else{
                commit('SET_USER', response.data )
              }
              resolve(response)
            })
        })
      }
    } catch (error) {
      commit('SET_TOKEN', null)
      commit('SET_USER', null)
    }
  },

  check_token({ dispatch }, token) {
    return new Promise((resolve, reject) => {
      axios.post("/auth/checkToken", {}, {
        headers: {
          'Authorization': `Bearer ${token}` 
        }
      })
        .then((response) => {
          if(response.data.success)
            dispatch('attempt', token)

          resolve(response)
        })
        .catch((error) => { 
          reject(error)
        })
    })
  },


  logout({ commit }, token) {
    console.log("logout action");
    return new Promise((resolve, reject) => {
      axios.post("/auth/logout", {token: token})
        .then((response) => {
          commit('REMOVE_TOKEN')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  getNotifications({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post("/auth/notifications")
        .then((response) => {
          commit('SET_NOTIFICATIONS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  readNotification({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.post(`/auth/readNotification/${itemId}`)
        .then((response) => {
          commit('READ_NOTIFICATION', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }



  // update({ commit }, data) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/auth/update", data)
  //       .then((response) => {
  //         if(response.data.success == false)
  //           dispatch('attempt', response.data.token)
  //         else
  //           commit('UPDATE', data.name)
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },

  // passwordUpate({ commit }, data) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/auth/passwordUpate", data)
  //       .then((response) => {
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },



}
